// extracted by css-extract-rspack-plugin
export default {"menuItem":"Bx_JJ","menuItemWithBorder":"ydSyF","menuItemStack":"sknCU"};